import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import { SidebarMenuButton } from '@savvy-kit/templates/sidebar';
import { Presentation } from 'lucide-react';

const CANVAS_HREF = '/advisor/canvas';

function CanvasMenuButton() {
  const pathname = usePathname() ?? '';
  const isActive = pathname === CANVAS_HREF || pathname.startsWith(`${CANVAS_HREF}/`);

  return (
    <SidebarMenuButton
      tooltip="Canvas"
      isActive={isActive}
      className="data-[active]:bg-component-hover data-[active]:text-primary"
      render={<NextLink href={CANVAS_HREF} className="relative flex items-center gap-2 w-full" />}
    >
      <Presentation className="size-4 shrink-0" />
      <span>Canvas</span>
      <span className="ml-auto text-[10px] font-medium uppercase tracking-wide text-secondary">v2</span>
    </SidebarMenuButton>
  );
}

export default CanvasMenuButton;
